import { clearWcpClientAuthState } from './session';

const GUEST_EXPLORE_SESSION_KEY = 'guestExploreIntent';
const GUEST_BROWSE_ALLOWED_KEY = 'guestBrowseAllowed';
const GUEST_EXPLORE_QUERY = 'guestExplore';

function hasGuestExploreQuery(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    try {
        return new URLSearchParams(window.location.search).get(GUEST_EXPLORE_QUERY) === '1';
    } catch {
        return false;
    }
}

export function isGuestExplorePending(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    try {
        return sessionStorage.getItem(GUEST_EXPLORE_SESSION_KEY) === '1';
    } catch {
        return false;
    }
}

export function hasGuestExploreIntent(): boolean {
    return isGuestExplorePending();
}

/** Persist Explore-as-guest from the login CTA (`?guestExplore=1`) before dest-login runs. */
export function captureGuestExploreFromUrl(): void {
    if (!hasGuestExploreQuery()) {
        return;
    }
    try {
        sessionStorage.setItem(GUEST_EXPLORE_SESSION_KEY, '1');
        sessionStorage.removeItem('wcpPendingDeepLink');
        sessionStorage.removeItem('redirect');
    } catch {
        /* ignore */
    }
    try {
        const url = new URL(window.location.href);
        url.searchParams.delete(GUEST_EXPLORE_QUERY);
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    } catch {
        /* ignore */
    }
}

/** Wipe prior WCP session when guest explore intent is active in sessionStorage. */
export function consumeGuestExploreIntent(): boolean {
    if (!isGuestExplorePending()) {
        return false;
    }

    clearWcpClientAuthState();
    return true;
}

export function completeGuestExploreIntent(): void {
    try {
        sessionStorage.setItem(GUEST_BROWSE_ALLOWED_KEY, '1');
        sessionStorage.removeItem(GUEST_EXPLORE_SESSION_KEY);
    } catch {
        // ignore
    }
}

/** Explicit explore-as-guest: this tab may browse without login. */
export function isGuestBrowseAllowed(): boolean {
    if (isGuestExplorePending() || hasGuestExploreQuery()) {
        return true;
    }
    if (typeof window === 'undefined') {
        return false;
    }
    try {
        return sessionStorage.getItem(GUEST_BROWSE_ALLOWED_KEY) === '1';
    } catch {
        return false;
    }
}
